const experimentalWarning = (componentTag) => {
  var _a;
  if (!((_a = window === null || window === void 0 ? void 0 : window.workbench) === null || _a === void 0 ? void 0 : _a.showExperimentalWarnings)) {
    return;
  }
  console.warn(`Workbench Notice: ${componentTag} component is currently in experimental stage. To disable these warnings set window.workbench.experimentalWarnings to false.`);
};

export { experimentalWarning as e };
